import { TaskSectionType } from './task-section-type.enum';

export type TaskSectionMetadata = TaskFieldSectionMetadata | TaskContainerSectionMetadata;

export interface TaskFieldSectionMetadata {
  id: string;
  type: Exclude<TaskSectionType, TaskSectionType.Container>;
}

export interface TaskContainerSectionMetadata {
  id: string;
  type: TaskSectionType.Container;
  children: TaskSectionMetadata[];
}

export type TaskSectionDropData = TaskSectionMetadata | TaskSectionType;

export const isSectionType = (type: TaskSectionDropData): type is TaskSectionType =>
  Object.values(TaskSectionType).includes(type as TaskSectionType);

export const isContainerSectionMetadata = (
  section: TaskSectionMetadata,
): section is TaskContainerSectionMetadata => section.type === TaskSectionType.Container;
